<template>
  <div class="user-info-shell">
    <b-modal
      id="modal-deposit"
      cancel-variant="outline-secondary"
      hide-footer
      centered
      size="lg"
      no-close-on-backdrop
      :title="$t('Secured Deposit')"
    >
      <div v-if="depositForm">
        <b-row>
          <b-col md="6">
            <b-form-group
              :label="$t('Amount') + ' *'"
              label-class="font-weight-bold"
              :invalid-feedback="$t('Invalid amount entered')"
              ref="d_amount"
              :description="
                $t('Total Remaining') + ': ' + depositDetails.remainingDeposit
              "
            >
              <b-form-input
                type="number"
                v-model.trim="depositObj.amount"
                :placeholder="$t('Enter amount')"
                @input="checkAmount()"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Return Date') + ' *'"
              label-class="font-weight-bold"
              :invalid-feedback="$t('Return Date is required.')"
              ref="d_date"
            >
              <flat-pickr
                :config="config"
                v-model="depositObj.date"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Receiving Person') + ' *'"
              label-class="font-weight-bold"
              :invalid-feedback="$t('Receiving Person is required')"
              ref="d_person"
            >
              <b-form-input
                v-model.trim="depositObj.receivingPerson"
                :placeholder="$t('Enter Receiving Person Name')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Bank Name')"
              :invalid-feedback="$t('Bank Name is required')"
              ref="d_bank"
            >
              <b-form-input
                v-model.trim="depositObj.bankName"
                :placeholder="$t('Enter Bank name')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :label="$t('Cheque No.')"
              :invalid-feedback="$t('Cheque No. is required')"
              ref="d_cheq"
            >
              <b-form-input
                v-model.trim="depositObj.chequeNo"
                :placeholder="$t('Enter Cheque No.')"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <!-- <b-col md="6">
            <b-form-group
              label="Collection Account"
              invalid-feedback="Collection account is required."
              ref="d_acc"
            >
              <v-select
                v-model="depositObj.accountID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="accTypes"
                :reduce="(opt) => opt.id"
                label="account"
                :clearable="false"
                placeholder="Select account"
              />
            </b-form-group>
          </b-col> -->
          <b-col md="12">
            <b-form-group
              :label="$t('Note')"
              :invalid-feedback="$t('Note is required.')"
              ref="d_note"
            >
              <b-form-textarea
                rows="3"
                :placeholder="$t('Enter note')"
                v-model.trim="depositObj.note"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div class="text-right py-1 border-top">
          <b-button
            variant="success"
            class="mr-1"
            :disabled="savingReturn"
            @click="returnDeposit()"
          >
            <b-spinner v-if="savingReturn" small type="grow" />
            <span v-else>{{ $t("Return") }}</span>
          </b-button>
          <b-button
            variant="outline-secondary"
            :disabled="savingReturn"
            @click="depositForm = false"
          >
            {{ $t("Cancel") }}
          </b-button>
        </div>
      </div>

      <b-row v-else>
        <b-col md="3">
          <b-button
            variant="primary"
            block
            @click="openReturn()"
            :disabled="depositLoading || depositDetails.remainingDeposit <= 0"
          >
            {{ $t("Return Deposit") }}
          </b-button>
        </b-col>
        <b-col md="12">
          <b-table
            class="mt-1"
            :items="returnedDeposits"
            :fields="depositFields"
            responsive
            show-empty
            small
            :busy="depositLoading"
          >
            <template #table-busy>
              <div class="d-flex justify-content-center my-2">
                <b-spinner
                  type="grow"
                  variant="primary"
                  :label="$t('Spinning')"
                ></b-spinner>
              </div>
            </template>

            <template #head()="scope">
              <div>
                <span>{{ $t(scope.label) }}</span>
              </div>
            </template>

            <template #cell(date)="data">
              {{
                new Date(data.value).toLocaleDateString("en-UK", {
                  year: "numeric",
                  day: "numeric",
                  month: "short",
                })
              }}
            </template>
            <template #cell(amount)="data">
              <b-badge variant="light-primary">
                {{ data.value }}
              </b-badge>
            </template>
          </b-table>

          <template v-if="!depositLoading">
            <hr />
            <div class="d-flex align-items-center mb-25">
              <h5 class="font-weight-bolder mb-0 mr-50">
                {{ $t("Total Deposited") }}:
              </h5>
              <b-badge variant="light-primary">
                {{ depositDetails.totalDeposit }}
              </b-badge>
            </div>
            <div class="d-flex align-items-center mb-25">
              <h5 class="font-weight-bolder mb-0 mr-50">
                {{ $t("Total Returned") }}:
              </h5>
              <b-badge variant="light-primary">
                {{ depositDetails.totalReturned }}
              </b-badge>
            </div>
            <div class="d-flex align-items-center">
              <h5 class="font-weight-bolder mb-0 mr-50">
                {{ $t("Remaining Deposit") }}:
              </h5>
              <b-badge variant="light-primary">
                {{ depositDetails.remainingDeposit }}
              </b-badge>
            </div>
          </template>
        </b-col>
      </b-row>
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility7"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Transfer Student") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="visibility7 = false"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row class="">
          <b-col md="12" class="mb-1">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                  size="44"
                  :src="getPicturePreview(chObj.picture)"
                  variant="light-primary"
                  referrerpolicy="no-referrer"
                />
              </template>

              <b-link
                class="font-weight-bold d-block text-nowrap"
                style="margin-bottom: 4px"
              >
                <b-badge variant="light-primary">
                  {{ chObj.name }}
                </b-badge>
              </b-link>
              <small class="text-muted">
                <b-badge variant="light-primary" class="mr-50">
                  {{ $t("GR") }} -
                  {{
                    reportDomain === "myskoolhpgs" ||
                    reportDomain === "myskoolprofectus"
                      ? chObj.grNoLocal
                      : chObj.grNo
                  }}
                </b-badge>
                <b-badge variant="light-primary" class="mr-50">
                  {{ $t("F#") }} - {{ chObj.family_code }}
                </b-badge>
                <b-badge variant="light-primary">
                  {{
                    reportDomain === "myskoolhpgs" ||
                    reportDomain === "myskoolprofectus"
                      ? $t("CID") + ": "
                      : $t("ID") + ": "
                  }}

                  {{
                    reportDomain === "myskoolhpgs" ||
                    reportDomain === "myskoolprofectus"
                      ? chObj.grNo
                      : chObj.id
                  }}
                </b-badge>
              </small>
            </b-media>
          </b-col>
          <b-col cols="12">
            <b-form-group :label="$t('Current Campus')">
              <b-badge variant="primary">
                {{ getCampus(chObj.campusID) }}
              </b-badge>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              :label="$t('Transfer to Campus')"
              :invalid-feedback="$t('Campus is required.')"
              ref="ch_camp"
            >
              <v-select
                v-model="chObj.newCampus"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="campuses"
                :clearable="false"
                label="branch"
                :reduce="(val) => val.id"
                :disabled="clsLoading"
                :placeholder="$t('Select campus')"
                @input="LoadClass()"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              :label="$t('Class')"
              :invalid-feedback="$t('Class is required')"
              ref="ch_cls"
            >
              <v-select
                v-model="chObj.clsID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="chOptions"
                :clearable="false"
                label="name"
                :reduce="(val) => val.id"
                :disabled="clsLoading"
                :placeholder="$t('Select class')"
                @input="FillChSec()"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              :label="$t('Section')"
              :invalid-feedback="$t('Section is required')"
              ref="ch_sec"
            >
              <v-select
                v-model="chObj.secID"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="chSections"
                :reduce="(opt) => opt.id"
                label="section"
                :clearable="false"
                :disabled="clsLoading"
                :placeholder="$t('Select section')"
                @input="checkChSec()"
              />
            </b-form-group>
          </b-col>

          <b-col class="mt-1" md="12">
            <b-button
              type="submit"
              variant="success"
              block
              :disabled="request"
              @click="saveCh()"
            >
              <b-spinner v-if="request" small type="grow" />
              <span v-else>{{ $t("Transfer") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <div class="user-info-inner">
      <div class="profile-summary text-center px-3 pb-2">
        <div class="avatar-wrapper mx-auto">
          <b-avatar
            :src="getPicturePreview(userData.picture)"
            :text="avatarText(userData.fullName)"
            variant="light-primary"
            size="100"
            class="profile-avatar"
            referrerpolicy="no-referrer"
          />
          <div
            class="status-indicator"
            :class="statusIndicatorClass"
            v-b-tooltip.hover
            :title="userData.status"
          ></div>
        </div>

        <h3 class="font-weight-bolder mb-0 text-primary-dark name-title">
          {{ userData.name }}
        </h3>
        <p v-if="userData.meta_class" class="designation-text mb-1">
          {{ userData.meta_class }}
        </p>

        <div class="d-flex flex-wrap justify-content-center badge-row mb-1">
          <b-badge
            :variant="getVariant(userData.status.toLowerCase())"
            class="text-uppercase py-50 px-1"
          >
            {{ userData.status }}
          </b-badge>
        </div>
      </div>

      <div class="info-line-list px-3 pb-2">
        <div
          v-for="item in sidebarInfoItems"
          :key="item.key"
          class="info-line"
        >
          <div class="info-line__icon">
            <feather-icon :icon="item.icon" size="16" />
          </div>
          <div class="info-line__content">
            <div class="info-line__label">{{ item.label }}</div>
            <div class="info-line__value">{{ item.value }}</div>
          </div>
        </div>
      </div>

      <div class="action-btn-row px-3 pb-3">
        <b-button
          v-if="allowEdit()"
          block
          class="mb-50"
          :to="{
            name: 'manage-student',
            params: { id: userData.id },
            query: {
              status: userData.status.toLowerCase(),
            },
          }"
          variant="primary"
        >
          {{ $t("Edit") }}
        </b-button>
        <b-button
          v-if="showLedger"
          block
          class="mb-50"
          variant="outline-primary"
          @click="loadLedger()"
          :disabled="ledgLoading"
        >
          <b-spinner
            v-if="ledgLoading"
            small
            variant="primary"
            class="mr-25"
          />
          <span>{{ $t("View Ledger") }}</span>
        </b-button>
        <b-button
          v-if="showDeposit"
          block
          variant="outline-primary"
          @click="openDeposit()"
          :disabled="depositLoading"
        >
          <span>{{ $t("Security Deposit") }}</span>
        </b-button>

        <!-- transfer move to user plan card -->
        <!-- <b-button
          v-if="
            reportDomain === 'myskoolhpgs' &&
            (userData.status.toLowerCase() == 'registered' ||
              (userData.status.toLowerCase() == 'present' &&
                $store.state.rights['manage-studentgrid'] &&
                $store.state.rights['manage-studentgrid'].editCampus))
          "
          variant="outline-primary"
          class="ml-1"
          @click="openCh()"
          >Transfer Campus
        </b-button> -->

        <!-- <b-button variant="outline-danger" class="ml-1"> Suspend </b-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BBadge,
  BSidebar,
  BMedia,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
  BLink,
  BTable,
  BFormTextarea,
  VBTooltip,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import useUsersList from "../users-list/useUsersList";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { getMediaPreviewUrl } from "@/utils/gdriveUpload";

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BBadge,
    BSidebar,
    BMedia,
    BForm,
    BFormGroup,
    BFormInput,
    BSpinner,
    BLink,
    BTable,
    BFormTextarea,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    campuses: {
      type: Array,
      required: true,
    },
    showLedger: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDeposit: {
      type: Boolean,
      required: false,
      default: false,
    },
    getCampus: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      chObj: {},
      visibility7: false,
      chOptions: [],
      chClasses: [],
      chSections: [],
      clsLoading: false,
      request: false,
      ledgLoading: false,
      accTypes: [],
      depositObj: {
        id: 0,
        sID: 0,
        date: null,
        amount: 0,
        receivingPerson: "",
        accountID: 0,
        bankName: "",
        chequeNo: "",
        note: "",
        status: "returned",
        postedOn: new Date().toJSON(),
        postedBy: this.$store.state.userData.userID,
        campusID: this.userData.campusID,
      },
      savingReturn: false,
      depositForm: false,
      depositLoading: false,
      returnedDeposits: [],
      depositFields: [
        { label: "date", key: "date" },
        { label: "amount", key: "amount" },
        { label: "received by", key: "receivingPerson" },
        { label: "note", key: "note" },
      ],
      depositDetails: {
        totalDeposit: 0,
        totalReturned: 0,
        remainingDeposit: 0,
      },
    };
  },
  computed: {
    statusIndicatorClass() {
      const st = String(this.userData?.status || "").toLowerCase();
      if (st === "present") return "bg-success";
      if (st === "registered") return "bg-warning";
      return "bg-danger";
    },
    sidebarInfoItems() {
      const items = [];
      const data = this.userData || {};
      const status = String(data.status || "").toLowerCase();
      const isHpgs = this.reportDomain === "myskoolhpgs";
      const isProfectus = this.reportDomain === "myskoolprofectus";
      const grLabel = isHpgs || isProfectus ? this.$t("CID") : this.$t("GR #");

      if (data.grNo) {
        items.push({
          key: "gr",
          icon: "HashIcon",
          label: grLabel,
          value: data.grNo,
        });
      }

      if (data.family_code) {
        items.push({
          key: "family",
          icon: "UsersIcon",
          label: this.$t("Family Code"),
          value: data.family_code,
        });
      }

      if (data.father_name) {
        items.push({
          key: "father",
          icon: "UserIcon",
          label: this.$t("Father Name"),
          value: data.father_name,
        });
      }

      if (isHpgs) {
        items.push({
          key: "campus-admitted",
          icon: "HomeIcon",
          label: this.$t("Admitted Campus"),
          value: this.getCampus(data.campus_Admitted),
        });
        items.push({
          key: "campus-current",
          icon: "MapPinIcon",
          label: this.$t("Current Campus"),
          value: this.getCampus(data.campusID),
        });
      }

      if (data.date_of_admission) {
        items.push({
          key: "admission",
          icon: "CalendarIcon",
          label: this.$t("Admission Date"),
          value: this.formatDisplayDate(data.date_of_admission),
        });
      }

      if (["left", "alumni"].includes(status) && data.date_of_leaving) {
        items.push({
          key: "leaving",
          icon: "LogOutIcon",
          label: this.$t("Leaving Date"),
          value: this.formatDisplayDate(data.date_of_leaving),
        });
      }

      items.push({
        key: "role",
        icon: "BriefcaseIcon",
        label: this.$t("Role"),
        value: this.$t("Student"),
      });

      if (data.nationality) {
        items.push({
          key: "nationality",
          icon: "FlagIcon",
          label: this.$t("Nationality"),
          value: data.nationality,
        });
      }

      if (data.contact_student) {
        items.push({
          key: "contact-student",
          icon: "SmartphoneIcon",
          label: this.$t("Student Contact"),
          value: data.contact_student,
        });
      }

      if (
        data.contact_father &&
        data.contact_father !== data.contact_student
      ) {
        items.push({
          key: "contact-father",
          icon: "PhoneIcon",
          label: this.$t("Father Contact"),
          value: data.contact_father,
        });
      } else if (!data.contact_student && data.contact_father) {
        items.push({
          key: "contact",
          icon: "PhoneIcon",
          label: this.$t("Contact"),
          value: data.contact_father,
        });
      }

      return items;
    },
  },
  setup() {
    const { resolveUserRoleVariant } = useUsersList();
    return {
      avatarText,
      resolveUserRoleVariant,
    };
  },
  methods: {
    ...mapActions({
      get: "get",
      post: "post",
      put: "put",
      delete: "delete",
    }),

    getPicturePreview(url) {
      if (!url) return "";
      if (String(url).startsWith("blob:")) return url;
      return getMediaPreviewUrl(url, "Image");
    },

    formatDisplayDate(value) {
      if (!value) return "—";
      return new Date(value).toLocaleDateString("en-UK", {
        year: "numeric",
        day: "numeric",
        month: "short",
      });
    },

    getVariant(st) {
      const vt =
        st == "present"
          ? "light-success"
          : st == "registered"
          ? "light-warning"
          : "light-danger";
      return vt;
    },
    allowEdit() {
      let rights = null;
      let st = this.userData.status.toLowerCase();
      if (["present", "registered", "left", "enrolled"].includes(st)) {
        rights = this.$store.state.rights["manage-studentgrid"];
      }
      if (this.reportDomain == "myskoolhpgs") {
        let other = null;
        if (st == "registered") {
          other = this.$store.state.rights["student-registered"];
        } else if (st == "enrolled") {
          other = this.$store.state.rights["student-enrolled"];
        }
        if (rights && !rights.edit && other) {
          rights = other;
        } else if (!rights && other) {
          rights = other;
        }
      }
      return rights ? rights.edit : false;
    },

    async openDeposit() {
      this.depositLoading = true;
      this.$bvModal.show("modal-deposit");
      this.depositForm = false;

      var obj = {
        url:
          this.$store.state.domain +
          "StudentSecurityDeposit/LoadData?db=" +
          this.$store.state.userData.db +
          "&sID=" +
          this.userData.id,
        token: this.$store.state.userData.token,
      };
      let res = await this.get(obj);
      if (res) {
        this.returnedDeposits = res?.returnedData || [];
        this.depositDetails = {
          totalDeposit: res?.totalDeposit || 0,
          totalReturned: res?.totalReturned || 0,
          remainingDeposit: 0,
        };
        this.depositDetails.remainingDeposit =
          this.depositDetails.totalDeposit - this.depositDetails.totalReturned;
      }
      this.depositLoading = false;
    },
    openReturn() {
      this.depositForm = true;
      this.depositObj = {
        id: 0,
        sID: this.userData.id,
        date: null,
        amount: this.depositDetails.remainingDeposit,
        receivingPerson: "",
        accountID: 0,
        bankName: "",
        chequeNo: "",
        note: "",
        status: "returned",
        postedOn: new Date().toJSON(),
        postedBy: this.$store.state.userData.userID,
        campusID: this.userData.campusID,
      };
    },
    checkAmount() {
      var elem = this.$refs["d_amount"];
      let x = parseInt(this.depositObj.amount);
      if (isNaN(x) || x <= 0 || x > this.depositDetails.remainingDeposit) {
        return (elem.state = false);
      } else {
        this.depositObj.amount = x;
        return (elem.state = true);
      }
    },
    checkDate() {
      var elem = this.$refs["d_date"];
      if (!this.depositObj.date) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkName() {
      var elem = this.$refs["d_person"];
      if (!this.depositObj.receivingPerson) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async returnDeposit() {
      let s1 = this.checkAmount();
      let s2 = this.checkDate();
      let s3 = this.checkName();

      if (s1 == false || s2 == false || s3 == false) {
        this.check = 1;
        this.$bvToast.toast(this.$t("Please enter the details correctly"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        console.log(this.depositObj);
        this.savingReturn = true;
        let status = await this.post({
          url:
            this.$store.state.domain +
            "StudentSecurityDeposit?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.userData.campusID,
          body: this.depositObj,
          message: this.$t("Deposit returned successfully."),
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) {
          this.depositForm = false;
          this.openDeposit();
        }
        this.savingReturn = false;
      }
    },

    async loadLedger() {
      if (!this.userData.id) {
        this.$bvToast.toast(this.$t("Please select a student first"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.ledgLoading = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "studentLedger/syncLedger?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.userData.campusID +
            "&sID=" +
            this.userData.id,
          context: this,
          importing: true,
          token: this.$store.state.userData.token,
        });
        this.ledgLoading = false;

        if (status) {
          var url =
            `https://${this.reportDomain}.myskool.app/Account/StudentLedger?dbb=` +
            this.$store.state.userData.db +
            "&cID=" +
            this.userData.campusID +
            "&sID=" +
            this.userData.id;

          window.open(url, "_blank");
        }
      }
    },

    openCh() {
      this.chObj = {
        ...this.userData,
        newCampus: 0,
        clsID: 0,
        secID: 0,
      };

      this.visibility7 = true;
      this.chSections = [];
      this.chClasses = [];
      this.chOptions = [];

      // console.log(this.chObj);
    },
    async LoadClass() {
      this.checkChCamp();
      this.clsLoading = true;
      this.chObj.clsID = 0;
      this.chObj.secID = 0;
      this.chSections = [];

      var obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.chObj.newCampus +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      //  this.items =[];
      let myitem = await this.get(obj);
      this.chClasses = myitem;
      this.chOptions = this.chClasses.map((el) => el.cls);

      this.clsLoading = false;
    },
    FillChSec() {
      this.chObj.secID = 0;
      this.chSections = [];
      let obj = this.chClasses.find((el) => el.cls.id == this.chObj.clsID);
      if (obj && obj.sections.length > 0) {
        this.chSections = obj.sections;
      } else this.chSections = [];

      this.checkChClass();
    },
    checkChCamp() {
      var elem = this.$refs["ch_camp"];
      if (this.chObj.newCampus == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkChClass() {
      var elem = this.$refs["ch_cls"];
      if (this.chObj.clsID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkChSec() {
      var elem = this.$refs["ch_sec"];
      if (this.chObj.secID == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveCh() {
      this.checkChCamp();
      this.checkChClass();
      this.checkChSec();
      if (
        this.checkChCamp() == false ||
        this.checkChClass() == false ||
        this.checkChSec() == false
      ) {
        this.$bvToast.toast(this.$t("Please select all the required fields"), {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      }
      // else if (this.chObj.campusID == this.chObj.newCampus) {
      //   this.$bvToast.toast("Current campus and transfer campus are same", {
      //     title: this.$t("Error!"),
      //     variant: "danger",
      //     toaster: "b-toaster-top-center",
      //   });
      // }
      else {
        let result = await Swal.fire({
          title: this.$t("Are you sure?"),
          text: "Do you want to transfer the student?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes!",
        });

        if (result.isConfirmed) {
          this.request = true;
          let data = {
            sID: this.chObj.id,
            previousCampus: this.chObj.campusID,
            newCampus: this.chObj.newCampus,
            clsID: this.chObj.clsID,
            secID: this.chObj.secID,
            userID: this.$store.state.userData.userID,
          };
          // console.log(data);

          let status = await this.post({
            url:
              this.$store.state.domain +
              "Students/TransferCampus?db=" +
              this.$store.state.userData.db,
            body: data,
            message: this.$t("Student transferred successfully!"),
            context: this,
            token: this.$store.state.userData.token,
          });
          this.request = false;
          if (status) {
            this.visibility7 = false;
            this.$router.go();
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info-inner {
  margin-top: 0;
  position: relative;
  z-index: 2;
  padding-top: 1rem;
}

.profile-summary {
  padding-top: 0.15rem;
}

.avatar-wrapper {
  position: relative;
  display: inline-block;
  padding: 4px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.profile-avatar {
  border: 3px solid #f0edff;
}

.status-indicator {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
}

.text-primary-dark {
  color: #2d1b69;
}

.gr-label {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  color: #7c5dfa;
}

.info-line-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.info-line {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.55rem 0.65rem;
  border: 1px solid #ece8ff;
  border-radius: 10px;
  background: #fdfcff;
}

.info-line__icon {
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #f3f0ff;
  color: #7c5dfa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-line__content {
  flex: 1;
  min-width: 0;
}

.info-line__label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #82868b;
  line-height: 1.2;
  margin-bottom: 0.15rem;
}

.info-line__value {
  font-size: 0.84rem;
  font-weight: 600;
  color: #2d1b69;
  line-height: 1.35;
  word-break: break-word;
}

.name-title {
  font-size: 1.15rem;
  line-height: 1.25;
  letter-spacing: -0.2px;
}

.designation-text {
  font-size: 0.78rem;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  font-weight: 700;
  color: #9d7aff !important;
  margin-bottom: 0.35rem !important;
}

.badge-row {
  gap: 0.35rem;
}

.action-btn-row .btn {
  border-radius: 10px;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 0.5rem 0.75rem;
}

@media (max-width: 767.98px) {
  .user-info-inner {
    padding-top: 0.75rem !important;
  }

  .action-btn-row {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .action-btn-row .btn {
    width: 100%;
  }

  .name-title {
    font-size: 1.05rem;
  }

  .info-line {
    padding: 0.5rem 0.55rem;
  }
}
</style>
